import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-configurations',
  templateUrl: './configurations.component.html'
})
export class ConfigurationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
